/*
* @Author: yongwenhao
* @Date: 2020-04-17 09:23:11
* @describe: 新增/编辑招聘职位
*/
<template>
  <KllkDrawer v-model="isShowDrawer" class="create-drawer">
    <!-- 按钮 -->
    <div slot="header" class="header-warp">
      <el-button type="primary" @click="onSave" class="btns">保存</el-button>
      <el-button @click="onCancel" class="btns">取消</el-button>
    </div>
    <el-form
      ref="offerForm"
      label-position="left"
      :model="offerForm"
      :rules="offerRules"
      label-width="90px"
      class="content"
    >
      <el-form-item label="职位名称" prop="positionName">
        <el-input v-model="offerForm.positionName" maxlength="32"></el-input>
      </el-form-item>
      <el-form-item label="招聘城市" prop="city">
        <el-input v-model="offerForm.city" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item label="薪酬" prop="payment">
        <el-input v-model="offerForm.payment" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item label="招聘时间">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="offerForm.range"
          @input="daterangeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="语言类型">
        <el-select
          v-model="offerForm.languageType"
          placeholder="请选择语言类型"
          style="width:100%"
        >
          <el-option label="中文" :value="0"></el-option>
          <el-option label="英文" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否发布">
        <el-select v-model="offerForm.isPublish" placeholder="请选择是否发布" style="width:100%">
          <el-option label="未发布" :value="0"></el-option>
          <el-option label="发布" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属公司">
        <el-select v-model="offerForm.companyId" placeholder="请选择所属公司" :disabled="companyIdFlag" style="width:100%">
          <el-option label="苏州科林利康医药科技有限公司" :value="1"></el-option>
          <el-option label="美达临床数据技术有限公司" :value="2"></el-option>
          <el-option label="科睿克（北京）临床医学研究有限公司" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位概要" prop="positionDescription">
        <el-input v-model="offerForm.positionDescription" maxlength="128"></el-input>
      </el-form-item>
      <el-form-item label="工作职责" prop="jobDuties">
        <QuillEditor
          :isShowImg="true"
          :quillBar="quillBar"
          ref="jobDuties"
          v-model="offerForm.jobDuties"
        ></QuillEditor>
        <div style="clear: both"></div>
      </el-form-item>
      <el-form-item label="任职要求" prop="jobRequirements">
        <QuillEditor
          :isShowImg="true"
          :quillBar="quillBar"
          ref="jobRequirements"
          v-model="offerForm.jobRequirements"
        ></QuillEditor>
        <div style="clear: both"></div>
      </el-form-item>
    </el-form>
  </KllkDrawer>
</template>

<script>
import KllkDrawer from "../../components/kllk-drawer";
import QuillEditor from "../../components/kllk-editor";
import { PostAddOffer, PutEditOffer } from "../../api/offer";

export default {
  name: "edit-add",
  props: {
    value: Boolean,
    infoFrom: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { KllkDrawer, QuillEditor },
  data() {
    return {
      isShowDrawer: this.value,
      companyIdFlag: sessionStorage.getItem('companyId') != 0,
      quillBar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction

        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],
        ["link", "image"],
        ["clean"], // remove formatting button
      ],
      offerForm: {
        positionName: "",
        positionDescription: "",
        jobDuties: "",
        jobRequirements: "",
        city: "",
        payment: "",
        range: "",
        languageType: 0,
        isPublish: 0,
        companyId: sessionStorage.getItem('companyId') == 0 ? 1 : parseInt(sessionStorage.getItem('companyId')),
      },
      offerRules: {
        positionName: [{ required: true, message: " ", trigger: "blur" }],
        positionDescription: [{ required: true, message: " ", trigger: "blur" }],
        jobDuties: [{ required: true, message: " ", trigger: "blur" }],
        jobRequirements: [{ required: true, message: " ", trigger: "blur" }],
        city: [{ required: true, message: " ", trigger: "blur" }],
        payment: [{ required: true, message: " ", trigger: "blur" }],
        range: [
          {
            type: "daterange",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        languageType: [{ required: true, message: " ", trigger: "change" }],
        isPublish: [{ required: true, message: " ", trigger: "change" }],
        companyId: [{ required: true, message: " ", trigger: "change" }],
      },
    };
  },
  watch: {
    value(n) {
      this.isShowDrawer = n;
    },
    isShowDrawer(n) {
      this.$emit("input", n);
      if (n) {
        this.$nextTick(() => {
          this.$refs.jobDuties.$refs.quill.quill.container.style.height =
            "calc(100% - 98px)";
        });
        if (Object.keys(this.infoFrom).length > 0) {
          this.offerForm = { ...this.infoFrom };
          const { dateStart, dateEnd, isPublish } = this.infoFrom;
          this.offerForm.range = [dateStart, dateEnd];
          this.offerForm.isPublish = Number(isPublish);
        }
      }
    },
  },
  methods: {
    onSave() {
      // 富文本内容
      this.offerForm.jobDuties = this.$refs.jobDuties.$refs.quill.value;
      this.offerForm.jobRequirements =
        this.$refs.jobRequirements.$refs.quill.value;
      this.$refs.offerForm.validate((valid) => {
        if (valid) {
          const { range } = this.offerForm;
          this.offerForm.dateStart = range[0];
          this.offerForm.dateEnd = range[1];
          if (this.offerForm.positionId) {
            // 修改
            const {
              positionId,
              positionName,
              positionDescription,
              jobDuties,
              jobRequirements,
              city,
              payment,
              dateStart,
              dateEnd,
              languageType,
              isPublish,
              companyId,
            } = this.offerForm;
            const params = {
              positionId,
              positionName,
              positionDescription,
              jobDuties,
              jobRequirements,
              city,
              payment,
              dateStart,
              dateEnd,
              languageType,
              isPublish: Number(isPublish),
              companyId,
            };
            PutEditOffer(params).then((res) => {
              if (res.status) {
                this.$notify.success({
                  title: "成功",
                  message: "修改成功",
                });
                this.$emit("on-update");
                this.onCancel();
              }
            });
          } else {
            // 新增
            PostAddOffer({ ...this.offerForm }).then((res) => {
              if (res.status) {
                this.$notify.success({
                  title: "成功",
                  message: "新增成功",
                });
                this.$emit("on-update");
                this.onCancel();
              }
            });
          }
        } else {
          this.$notify.error({
            title: "错误",
            message: "请填写正确的信息",
          });
          return false;
        }
      });
    },
    onCancel() {
      this.isShowDrawer = false;
      this.offerForm = {
        positionName: "",
        jobDuties: "",
        jobRequirements: "",
        city: "",
        payment: "",
        range: "",
        languageType: 0,
        isPublish: 0,
        companyId: sessionStorage.getItem('companyId') == 0 ? 1 : parseInt(sessionStorage.getItem('companyId')),
      };
    },
    daterangeChange(e) {
      let _this = this;
      console.log(e);
      _this.$nextTick(() => {
        _this.$set(_this.offerForm, "date", [e[0], e[1]]);
        _this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang='less' scoped>
.create-drawer {
  .header-warp {
    background: #f5f8fa;
    padding: 16px;

    .btns {
      margin: 0 5px;
    }
  }

  .content {
    padding: 20px;
  }
}
</style>
